import { useState } from 'react';
import ModalComp from 'components/Modal';
import CenteredWrapper from 'pages/updatePassword/CenteredWrapper';
import { Stack } from '@mui/material';
import Input from 'components/Input';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import CustomButton from 'components/Button';
import SaveIcon from '@mui/icons-material/Save';
import { useSelector, useDispatch } from 'react-redux';
import { authPostRequest } from 'Api/api';
import SuccessError from 'components/SuccessError';
import Loader from 'components/Loader';
import { checkIsProductNameValid, isStringEmpty } from 'utils/utils';
import { addProject } from 'reduxStore/authSlice';

const InputFeilds = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    maxLength: 149,
    placeholder: 'Enter project name',
    required: true
  },

  {
    name: 'description',
    label: 'Description',
    type: 'text',
    maxLength: 499,
    placeholder: 'Enter project description',
    required: true
  }
];
const CreateProject = ({
  openModal,
  setOpenModal,
  setIsFormSaved,
  isFormSaved,
  project,
  setProjectInf,
  projectBasePrice
}) => {
  const [projectInfo, setProjectInfo] = useState({
    name: project ? project.name?.trim() : '',
    description: project ? project.description?.trim() : ''
  });
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const { userData, storeData, adminAccess } = useSelector((store) => store.auth);
  const [errorMessage, setErrorMessage] = useState([]);
  const [successMessage, setSuccessMessage] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Input Handler
  const handleProject = (e) => {
    setProjectInfo({ ...projectInfo, [e.target.name]: e.target.value });
    handleError(e.target.name, null);
  };

  //Error handler
  const handleError = (input, errorMessage) => {
    setErrors((prevState) => ({ ...prevState, [input]: errorMessage }));
  };

  const validateRoofSection = () => {
    const isEmptyName = isStringEmpty(projectInfo.name);
    if (isEmptyName) {
      handleError('name', 'Please enter  name');
    }

    const isEmptyDescription = isStringEmpty(projectInfo.description);
    if (isEmptyDescription) {
      handleError('description', 'Please enter  description');
    }

    const nameCheck = checkIsProductNameValid(projectInfo.name);
    if (nameCheck) {
      handleError('name', 'Please do not use special characters in name ');
    }

    if (!isEmptyName && !nameCheck && !isEmptyDescription) {
      setErrors({});
      return true;
    }

    return false;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setErrorMessage([]);

    const requestParams = {
      userId: userData.userId,
      projectId: project ? project.id : '',
      storeId: adminAccess ? storeData?.id : userData?.storesList[0]?.storeId,
      name: projectInfo.name?.trim(),
      description: projectInfo.description?.trim(),
      price: projectBasePrice
    };

    setShowLoader(true);

    const validProject = validateRoofSection();
    const createProject = validProject && (await authPostRequest('saveProject', requestParams));

    if (createProject) {
      setShowAlertBar(true);
      if (createProject.resStatus === 1) {
        dispatch(addProject(createProject.objectId));
        setShowLoader(false);
        if (project) {
          setProjectInf({ ...projectInfo, [e.target.name]: e.target.value });
        }

        setIsFormSaved(!isFormSaved);
        if (project) {
          localStorage.removeItem('visited', true);
        } else {
          localStorage.setItem('visited', true);
        }

        setTimeout(
          () => {
            setOpenModal(false);
            navigate('/StoreInfo/roof-section', {
              state: {
                index: {
                  id: createProject.objectId,
                  name: projectInfo.name,
                  description: projectInfo?.description
                }
              }
            });
          },
          project ? 800 : 1500
        );
        setShowLoader(false);
        setSuccessMessage([createProject.resMessage]);
        !project &&
          setProjectInfo({
            name: '',
            description: ''
          });
      } else {
        setErrorMessage([createProject.resMessage]);
      }
    }

    setShowLoader(false);
  };
  return (
    <CenteredWrapper sx={{ minWidth: '60%' }}>
      <ModalComp
        open={openModal}
        setOpen={setOpenModal}
        header={project ? 'Update Project' : 'Create Project'}>
        {showAlertBar && (
          <SuccessError
            successMessage={successMessage}
            errorMessage={errorMessage}
            setShowAlertBar={setShowAlertBar}
          />
        )}
        {showLoader && <Loader open={showLoader} />}

        <form onSubmit={submitHandler}>
          {InputFeilds.map(({ name, type, placeholder, label, required, maxLength }) => (
            <Stack key={name} direction="row" sx={{ marginTop: '3vh' }}>
              <Input
                type={type}
                placeholder={placeholder}
                onChange={handleProject}
                value={projectInfo[name]}
                required={required}
                maxLength={maxLength}
                label={label}
                onFocus={() => handleError(name, null)}
                name={name}
                error={errors[name]}
              />
            </Stack>
          ))}
          <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '5vh' }}>
            <CustomButton
              sx={{ ml: '15vh' }}
              type="submit"
              onClick={submitHandler}
              endIcon={<SaveIcon />}>
              Save
            </CustomButton>
          </Stack>
        </form>
      </ModalComp>
    </CenteredWrapper>
  );
};

CreateProject.propTypes = {
  openModal: PropTypes.bool,
  isFormSaved: PropTypes.bool,
  setIsFormSaved: PropTypes.func,
  setOpenModal: PropTypes.func,
  setSuccess: PropTypes.func,
  setAlertBar: PropTypes.func,
  project: PropTypes.object,
  setProjectInf: PropTypes.func,
  projectBasePrice: PropTypes.number
};
export default CreateProject;
